export const categories = [
  {
    id: "cut-style",
    number: "01",
    title: "Cut & Style",
    eyebrow: "Hair · Beauty · Scalp",
    sections: [
      {
        services: [
          { name: "Women's Cut & Style", price: "$100 – $150", desc: "A customized haircut designed around your hair texture, lifestyle and personal style." },
          { name: "Men's Cut & Style", price: "$40 – $60", desc: "Precision cutting and styling tailored to your individual look." },
          { name: "Blowout & Style", price: "$50 – $100", desc: "Professional shampoo, blow-dry and finished style." },
          { name: "Special Occasion Styling", price: "$120 – $180", desc: "Polished styling, waves, curls and updos for your special event." },
        ],
      },
    ],
  },
  {
    id: "colour",
    number: "02",
    title: "Colour",
    eyebrow: "Dimension · Depth · Shine",
    sections: [
      {
        services: [
          { name: "Root Colour & Grey Coverage", price: "$80 – $90 + colour usage", desc: "Seamless coverage that blends new growth for a naturally refreshed root." },
          { name: "Full Colour", price: "$85 – $100 + colour usage", desc: "An all-over colour application for a complete, even transformation." },
          { name: "Partial Highlights & Lowlights", price: "$130 – $160 + colour usage", desc: "Dimensional lightening and depth, placed to frame your favourite features." },
          { name: "Full Highlights", price: "$190 – $250 + colour usage", desc: "Head-turning, all-over dimension for maximum brightness." },
          { name: "Balayage", price: "$300 & up + colour usage", desc: "Customized placement for soft, dimensional and beautifully blended colour." },
          { name: "Global Scalp Bleach", price: "$120 – $160 + colour usage", desc: "A full lightening service from the scalp for the boldest, brightest base." },
          { name: "Gloss & Toner", price: "$75 + colour usage", desc: "Refresh tone, enhance shine and bring your colour back to life." },
          { name: "Colour Transformation & Correction", onConsult: true, desc: "Advanced colour services for clients looking for a significant change or correction." },
        ],
      },
    ],
    note: "Colour consultations are recommended for major transformations and corrective services.",
  },
  {
    id: "hair-treatments",
    number: "03",
    title: "Hair Treatments",
    eyebrow: "Repair · Restore · Renew",
    sections: [
      {
        services: [
          { name: "Repair & Strengthen", price: "$30 – $70", desc: "Professional treatments designed to support compromised or chemically treated hair." },
          { name: "Hydration & Conditioning", onConsult: true, desc: "Restore moisture, softness and manageability." },
          { name: "Bond-Building Treatments", onConsult: true, desc: "Help strengthen and protect the internal structure of the hair." },
          { name: "Customized Hair Treatment", onConsult: true, desc: "Selected by your stylist according to the current needs of your hair." },
        ],
      },
    ],
  },
  {
    id: "extensions",
    number: "04",
    title: "Hair Extensions",
    eyebrow: "Length · Volume · Transformation",
    sections: [
      {
        services: [
          { name: "Extension Consultation", onConsult: true, desc: "A personalized assessment to determine the right length, density and method for your hair." },
          { name: "Custom Extension Installation", onConsult: true, desc: "Expert application for seamless, natural-looking length and volume." },
          { name: "Volume Enhancement", onConsult: true, desc: "Added fullness and body for effortlessly voluminous hair." },
          { name: "Length Enhancement", onConsult: true, desc: "Beautifully blended length that moves and feels like your own." },
          { name: "Extension Maintenance", onConsult: true, desc: "Routine care to keep your extensions healthy, secure and looking their best." },
          { name: "Extension Removal & Reinstallation", onConsult: true, desc: "Safe removal and reapplication to extend the life of your extensions." },
          { name: "Custom Cutting & Blending", onConsult: true, desc: "Precision cutting to seamlessly blend extensions with your natural hair." },
        ],
      },
    ],
    note: "Every extension service begins with a consultation to determine colour, length, density and the most appropriate method for your hair.",
  },
  {
    id: "bridal",
    number: "05",
    title: "Bridal & Special Events",
    eyebrow: "Beautiful Hair for Life's Most Important Moments",
    sections: [
      {
        label: "Hair",
        services: [
          { name: "Bridal Consultation", onConsult: true, desc: "A one-on-one session to plan your vision for hair on the big day." },
          { name: "Bridal Trial", price: "$195 – $250", desc: "A full run-through of your wedding-day hair, styled exactly as planned." },
          { name: "Wedding Day Hair", price: "$400 & up", desc: "Flawless, camera-ready styling for your wedding day." },
          { name: "Bridal Party Styling", price: "$150 & up", desc: "Beautifully coordinated styling for your bridesmaids and party." },
          { name: "Mother of the Bride & Groom", price: "$150 & up", desc: "Polished, elegant styling for the mothers of the day." },
        ],
      },
      {
        label: "Makeup",
        services: [
          { name: "Bridal Consultation", onConsult: true, desc: "A personalized consultation to define your bridal beauty look." },
          { name: "Bridal Trial", price: "$175 – $200", desc: "A complete trial run of your wedding-day makeup, from base to finish." },
          { name: "Wedding Day Makeup", price: "$250 & up", desc: "Long-wearing, radiant makeup application for your wedding day." },
          { name: "Bridal Party Makeup", price: "$150 & up", desc: "Flawless makeup application for your bridesmaids and party." },
          { name: "Mother of the Bride & Groom", price: "$150 & up", desc: "Timeless, elegant makeup for the mothers of the day." },
        ],
      },
    ],
    note: "Our bridal services are customized to create a look that complements the bride, the dress and the overall vision for the day.",
  },
  {
    id: "scalp-lounge",
    number: "06",
    title: "The Scalp Lounge",
    eyebrow: "Scalp Care Is Not Hair Care",
    intro: "Our specialized scalp therapy services begin with understanding the scalp first.",
    sections: [
      {
        services: [
          { name: "Professional Scalp Analysis", price: "Complimentary", desc: "An in-depth assessment of your scalp's health, using our professional-grade tools." },
          { name: "Signature Scalp Therapy", price: "$150", desc: "Our foundational scalp treatment ritual for balance and relief." },
          { name: "Deep Scalp Cleansing & Detoxification", price: "$180", desc: "A deep-cleansing treatment to purify and detoxify the scalp." },
          { name: "Scalp Rebalancing", price: "$150", desc: "Restores balance to an overactive or sensitive scalp." },
          { name: "Dry & Flaky Scalp Therapy", price: "$180", desc: "Targeted therapy to soothe dryness, flaking and irritation." },
          { name: "XL Scalp Therapy", price: "$190", desc: "An extended, immersive scalp therapy session for deeper results." },
        ],
      },
    ],
    highlight: "Every session concludes with a Personalized Home-Care Prescription tailored to your scalp's needs.",
    note: "Our scalp therapy services are customized according to what we observe during your professional scalp analysis. We do not diagnose medical scalp conditions. When appropriate, we may recommend that a client consult a medical professional.",
  },
];

export const closingStatement =
  "We believe the best results begin with a thorough consultation and a plan designed specifically for you.";

export const marqueeText =
  "Experience · Education · Personalized Care  —  Hair · Colour · Extensions · Bridal · Scalp Therapy  —  Picaso Studios";
